import type { ApiClient } from './client.js';

export type OrganizationStatus = 'pending' | 'approved' | 'blocked';

export interface AdminOrganizationDto {
  id: string;
  entraTenantId: string;
  displayName: string;
  status: OrganizationStatus;
  approvedAt: string | null;
  approvedBy: string | null;
  notes: string | null;
  enabledThemeKeys: string[];
  createdAt: string;
  updatedAt: string;
  usage: {
    teacherCount: number;
    activeTeacherCount: number;
    classroomCount: number;
    activeClassroomCount: number;
    lastLoginAt: string | null;
  };
}

export interface AdminApi {
  listOrganizations(): Promise<AdminOrganizationDto[]>;
  approveOrganization(id: string): Promise<AdminOrganizationDto>;
  updateOrganizationThemes(id: string, enabledThemeKeys: string[]): Promise<AdminOrganizationDto>;
}

export function createAdminApi(client: ApiClient): AdminApi {
  return {
    async listOrganizations() {
      const res = await client.get<{ organizations: AdminOrganizationDto[] }>(
        '/api/admin/organizations',
      );
      return res.organizations;
    },
    async approveOrganization(id) {
      const res = await client.post<{ organization: AdminOrganizationDto }>(
        `/api/admin/organizations/${id}/approve`,
      );
      return res.organization;
    },
    async updateOrganizationThemes(id, enabledThemeKeys) {
      const res = await client.put<{ organization: AdminOrganizationDto }>(
        `/api/admin/organizations/${id}/themes`,
        { enabledThemeKeys },
      );
      return res.organization;
    },
  };
}
